/**
 * displayOrder of HeatingCostModal's cost positions.
 *
 * "CO2-Steuer Erstattung Vermieteranteil" is pinned to 99 (the backend creates it with 99) so it
 * always renders last; every other position is numbered 1..n above it. The modal used to derive a
 * new position's order from whichever row happened to be last or second to last in the array, so
 * once the CO2 row was last a new position got 99 + 1 = 100 and sorted below it, and two positions
 * could get the same number. Positions saved that way are renumbered by normalizeDisplayOrder.
 */
export const CO2_TAX_RETURN_DISPLAY_ORDER = 99;

const isSaved = (cp) => cp.id !== 0;

// order for a new position: right after the last non-CO2 position
export const nextDisplayOrder = (costPositions, isCO2TaxReturnRow) =>
  costPositions
    .filter((cp) => isSaved(cp) && !isCO2TaxReturnRow(cp))
    .reduce((max, cp) => Math.max(max, Number(cp.displayOrder) || 0), 0) + 1;

/**
 * Renumbers the non-CO2 positions 1..n, keeping their current relative order (ties keep the
 * API's order), and puts the CO2 row on 99. Returns the positions in display order and whether
 * any displayOrder changed, i.e. whether the new order needs saving.
 */
export const normalizeDisplayOrder = (costPositions, isCO2TaxReturnRow) => {
  const others = costPositions
    .map((cp, index) => ({ cp, index }))
    .filter(({ cp }) => !isCO2TaxReturnRow(cp))
    .sort((a, b) => (Number(a.cp.displayOrder) || 0) - (Number(b.cp.displayOrder) || 0) || a.index - b.index)
    .map(({ cp }, i) => ({ ...cp, displayOrder: i + 1 }));
  const co2 = costPositions
    .filter(isCO2TaxReturnRow)
    .map((cp) => ({ ...cp, displayOrder: CO2_TAX_RETURN_DISPLAY_ORDER }));
  const normalized = [...others, ...co2];
  const changed = normalized.some((cp) => cp.displayOrder !== costPositions.find((old) => old.id === cp.id).displayOrder);
  return { costPositions: normalized, changed };
};
